<template>
    <rkm-area
        background-color="primary"
        title="Pré-natal, parto e nascimento"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-select
                    :options="data.form.preNatal.gravidezTipos"
                    label="Tipo de gravidez"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.preNatal.gravidezTipoId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.alturaUterina"
                    append="cm"
                    label="Altura uterina"
                    number
                    v-model="data.model.preNatal.alturaUterina"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-group label="Risco da gravidez">
                    <rkm-badge
                        :color="data.additionals.hasGravidezAltoRisco || data.model.preNatal.gravidezAltoRisco ? 'danger' : 'primary'"
                        class="rkm-badge"
                    >
                        {{data.additionals.hasGravidezAltoRisco || data.model.preNatal.gravidezAltoRisco ? 'Alto' : 'Habitual'}}
                    </rkm-badge>
                </rkm-form-group>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-radio-group
                    :options="data.form.preNatal.edemas"
                    label="Edema"
                    text-field="nome"
                    v-model="data.model.preNatal.edemaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-radio-group
                    label="Movimentação fetal"
                    v-model="data.model.preNatal.movimentacaoFetal"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col
                v-if="data.additionals.isRascunho || !gravidezPlanejada"
                cols="2"
            >
                <rkm-form-radio-group
                    label="Gravidez planejada"
                    v-model="data.model.preNatal.gravidezPlanejada"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.batimentoCardiacoFetal"
                    append="bpm"
                    label="Batimento cardíaco fetal"
                    number
                    v-model="data.model.preNatal.batimentoCardiacoFetal"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="!data.additionals.isPrimeiroAtendimentoPreNatal">
            <rkm-col cols="2">
                <rkm-form-date-picker
                    :max-date="data.additionals.dataAtual"
                    :min-date="data.additionals.paciente.dataNascimento"
                    label="DUM"
                    v-model="data.model.dum"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-date-picker
                    :value="data.form.ultimaDum ? others.moment(data.form.ultimaDum, 'DD/MM/YYYY').toDate() : null"
                    disabled
                    label="Última DUM"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-date-picker
                    :value="dpp"
                    disabled
                    label="DPP"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Others.
import moment from 'moment'

export default {
    computed: {
        dpp() {
            const dum = this.data.model.dum ? this.others.moment(this.data.model.dum) : this.others.moment(this.data.form.ultimaDum, 'DD/MM/YYYY')
            let dpp = null

            if (dum) {
                dpp = dum.add(9, 'months').add(7, 'days').toDate()
            }

            return dpp
        },
        validations() {
            return {
                alturaUterina: {
                    min_value: 7,
                    max: 2,
                },
                batimentoCardiacoFetal: {max: 3},
            }
        },
    },
    created() {
        this.gravidezPlanejada = this.data.model.preNatal.gravidezPlanejada
    },
    data: () => ({
        gravidezPlanejada: false,
        others: {moment},
    }),
    props: {
        data: {type: Object, required: true},
    },
}
</script>

<style scoped>
.rkm-badge {
    font-size: 16px !important;
}
</style>